/** Settings → Security: second factors, recovery codes, sessions, password. */
export default {
  title: "Security",
  lead: "Who can sign in to your account, and how: the second factor, recovery codes, devices and password.",
  mfa: {
    title: "Two-step verification",
    on: "On",
    off: "Off",
    requiredStaff: "Required for staff: the admin area stays closed until you add a second factor.",
    recommended: "Recommended: protects your account and payouts even if your password leaks.",
    addTotp: "Add authenticator app",
    addKey: "Add security key or passkey",
    keyLabel: "Key name",
    keyLabelDefault: "Security key",
    remove: "Remove",
    lastUsed: "Last used {when}",
    never: "never used",
    totpScan: "Scan this code in Google Authenticator, 1Password, Authy or a similar app, or enter the key by hand.",
    totpSecret: "Key",
    totpConfirm: "Enter the 6-digit code from the app",
    factorTotp: "Authenticator app",
    factorWebauthn: "Security key",
  },
  recovery: {
    title: "Recovery codes",
    left: { one: "{count} unused code", other: "{count} unused codes" },
    regenerate: "Generate new codes",
    show: "Save these codes somewhere safe. Each works once; they are shown only now.",
    copy: "Copy",
    copied: "Copied",
    done: "I saved them",
  },
  stepUp: {
    title: "Confirm it is you",
    hint: "Sensitive changes need a fresh confirmation (valid 5 minutes).",
    confirm: "Confirm",
    cancel: "Cancel",
    activeUntil: "Confirmed until {time}",
    telegramHint: "Confirm in Telegram: tap the button and approve in our bot.",
  },
  sessions: {
    title: "Signed-in devices",
    current: "This device",
    revoke: "Sign out",
    revokeAll: "Sign out everywhere",
    revokeAllConfirm: "Sign out all devices, this one too?",
    since: "Since {when}",
    seen: "Active {when}",
    unknownDevice: "Unknown browser",
    showAll: "Show all {n}",
    showLess: "Show fewer",
  },
  password: {
    title: "Password",
    current: "Current password",
    new: "New password",
    change: "Change password",
    changed: "Password changed. Other devices were signed out.",
  },
  profile: {
    title: "Profile",
    save: "Save",
    saved: "Saved",
    telegram: "Telegram",
    telegramLinked: "Linked",
  },
} as const;
